export default __webpack_public_path__ + "static/media/Ee.f223c038.wav";